import { JsonAny } from "../common/Types";
import parseISO from "date-fns/parseISO";

export function isUser(roles: UserRole[] | undefined) {
    return roles?.length === 0;
}

export function isAdmin(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "ADMIN");
}

export function isPresenter(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "PRESENTER");
}

export function isPresenterAndAdmin(roles: UserRole[] | undefined) {
    return (
        !!roles?.some((role) => role.role === "PRESENTER") &&
        !!roles?.some((role) => role.role === "ADMIN")
    );
}

export interface UserData extends User {
    roles: UserRole[];
    skills: UserSkill[];
    histories: WatchHistory[];
    token?: string | null;
    refreshToken?: string | null;
}

// ユーザーログインリクエスト
export interface UserLogin {
    email: string;
    fullName: string;
    isNew?: boolean;
    profileImageUrl: string;
    organization: string;
    localAccountId: string;
    token: string;
}

export interface User {
    id: string;
    email: string;
    lastLogin: Date;
    fullName: string;
    imageUrl: string;
    updated: Date;
    created: Date;
    organization: string;
    localAccountId: string;
    roles: UserRole[];
}

export type Role = "PRESENTER" | "ADMIN";
export interface UserRole {
    userId: string;
    id: string;
    role: Role;
    created: Date;
}
export interface UserItems {
    id: string;
    fullName: string;
    organization?: string;
    localAccountId?: string;
    profileImageUrl: string;
}

// ユーザースキル定義
export interface UserSkill {
    id: number;
    userId?: number | null;
    skill: string;
    created?: Date | null;
}

export interface WatchHistory {
    videoId: string;
    watchTimestamp: string;
    isFinished: boolean;
}

// ユーザー一覧取得
export interface UserList {
    id: string;
    imageUrl: string;
    fullName: string;
    email: string;
    organization: string;
    localAccountId: string;
    lastLogin: string;
    skills: number[];
    skillList: UserSkill[];
    group: Group[];
    roles: string[];
    loginIn45days: boolean;
}

// ユーザ一覧更新
export interface UpdateUserList {
    id: string;
    imageFile: any;
    fullName: string;
    skills: number[];
    skillList: UserSkill[];
    roles: string[];
    group: Group[];
}

export function mapRolesToStrings(user: UserData) {
    const { roles } = user;
    if (!roles || roles.length === 0) {
        return "User";
    }

    return roles
        .map((role) => {
            if (role.role === "PRESENTER") {
                return "Professional";
            } else if (role.role === "ADMIN") {
                return "Admin";
            }

            return "";
        })
        .join(", ");
}

// ユーザーグループ
export interface Group {
    id: string;
    title: string;
    documentIds: number[];
    description: string;
    videoList: GroupVideo[];
    slideList: GroupSlide[];
    userList: User[];
}
export interface GroupVideo {
    id: string;
    title: string;
}
export interface GroupSlide {
    id: string;
    title: string;
}
export interface UpdateGroup {
    id: string;
    title: string;
}

export function parseUser(json: JsonAny): User {
    return {
        ...json,
        lastLogin: parseISO(json.lastLogin),
        created: parseISO(json.created),
        updated: parseISO(json.updated),
    };
}

// グループ生成
export function createGroup(
    id: string,
    title: string,
    documentIds: number[],
    description: string,
    userList: User[],
    videoList: GroupVideo[],
    slideList: GroupSlide[]
): Group {
    return {
        id: id,
        title: title,
        documentIds: [],
        description: description,
        videoList: videoList,
        userList: userList,
        slideList: slideList,
    };
}

// アクセス可能なドメイン定義
export interface AccessableEmailDomain {
    id: number;
    emailDomain: string;
    created?: Date;
    createdUserId?: number;
}

// アクセス可能なEMAIL定義
export interface AccessableEmail {
    id: number;
    email: string;
    created?: Date;
    createdUserId?: number;
}
// ユーザーライセンス情報
export interface UserLicense {
    licenses: number;
    activeUsers: number;
}
